<script setup>
import LegalModal from '@/components/legal/LegalModal.vue';
import { ref, computed } from 'vue';
import YBtn from '@/components/common/form/YBtn/YBtn.vue';
import LocalStorage from '@/controller/LocalStorage.js';
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
const props = defineProps({
    isModalActive: {
        type: Boolean,
        default: true
    }
});

const { t } = useI18n();
const router = useRouter();
;
const isHome = computed(() => router.currentRoute.value.path === '/')

//Rutas fuera de login
const isLogged = computed(() => {
  const excludedRoutes = [
    "login",
    "register",
    "logout",
    "invitations",
    "activate",
    "recoverAccount",
    "brandLogin",
    "recoverPassword",
  ];
  return !excludedRoutes.includes(router.currentRoute.value.name);
});




// Estas rutas no tinenen los textos legales
const isSpecialRoute = computed(() => {
  const specialRoutes = [
     
    "activate"
  ];
  return specialRoutes.includes(router.currentRoute.value.name);
});

const isRecovery = computed(() => {
  const recoveryPath = [

    "recoverAccount"
  ];
  return recoveryPath.includes(router.currentRoute.value.name);
});
const showLegal = ref(false);
const showLogMod = ref(false);
const userTertiaryColor = ref(LocalStorage.getColorTertiary());
function showLegalModal() {
  showLegal.value = true;
}
function updateShow(value) {
  showLegal.value = value;
}


function transformTitle(title) {
  if (!title) return '';
  return title.charAt(0) + title.slice(1).toLowerCase();
}

function showLoginModal(){
  showLogMod.value = true;
}

function updateShowClauses(value) {
  showLogMod.value = value;
}





</script>

<template>
  <div :class="[isHome ? 'footer-home': (isSpecialRoute? 'footer-notPoweredBy': (isLogged ? 'footer-default' : 'footer-notLogged')), isRecovery ? 'footer-recovery' : '']" class="footer" v-if="!$route.meta.hideFooter">
    <div class="legal-links">
      <YBtn size="xl" color="transparent" :label="transformTitle(t('use.title'))" :rounded="true" roundedSize="full"
        type="button" class="yauty-button" variant="link" noUnderline contentClass="underline-animation"
        @click="showLegalModal">
      </YBtn>
    </div>
  </div>
  <LegalModal :show="showLegal && isModalActive" @update:show="updateShow" />
</template>

<style lang="scss">



.footer {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: transparent;
  //width: 400px;
  min-height: 40px;
  z-index: 3;
  @media (max-width:576px) {
    padding-left: 15px;
  }
  @media (min-width: 769px) and (max-width: 1367px) and (orientation: landscape) {
    padding-left: 8dvw;
  }
  @media (min-width: 1025px) and (max-width: 1280px) {
    padding-left: 8dvw;
  }
  @media (min-width: 1281px) {
    padding-left: 8dvw;
  }
  .legal-links{
    font-family: 'CircularStd-Book';
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    flex-wrap: wrap;
    justify-content: center;
  }
  .underline-animation {
    color: #c6cfcf;
    &::before {
      background-color: #c6cfcf;
    }
  }
}

.footer-default{
  background-color: #EFF3F3;
  padding-left: calc(5dvw + 45px);
  @media (max-width: 576px) {
    padding-left: 10px;
    position: fixed;
    width: 100%;
  }
}

.footer-notLogged{
  background-color: transparent;
  top: 1dvh;
  max-width: 100dvw;
  flex-wrap: wrap;
  display: flex; 
  flex-direction: row;
  
  @media (min-width: 1025px) {
    padding-right: 1dvw;
    top: 1dvh;
    justify-self: end;
    z-index: 0;
    @media (max-width: 1180px) {
      top: -0.5rem;
      padding-right: 0;

    }
  }
  
  
  .yauty-button {
  font-family: 'CircularStd-Book';
  font-size: 14px !important;
  color: #c6cfcf;
  text-decoration: none;

  @media (min-width: 1025px) and (max-width: 1180px) and (orientation: landscape) {
    right: 2rem;
    top: 1rem;
  }
 
}

  @media (min-width: 1181px) and (max-width: 1399px) and (orientation: landscape) {
    // position: absolute;
    // left: 45.2%;
    // top: 95dvh;
    color: #B7B7B7;

    
    
  }

  @media (min-width: 1025px) and (max-width: 1180px) and (orientation: landscape) {
    // position: absolute;
    // left: 45.45%;
    // top: 91dvh;
    color: #B7B7B7;
    
    
  }
  @media (min-width: 1025px) and (max-width: 1399px) and (orientation: landscape) {
    bottom: 0rem !important;
    
  }
  @media (max-width: 1024px) and (orientation: portrait) {
    position:relative;
    justify-content: center;
    top: -3.5rem;
    
  }

  

  @media (max-width: 375px) and (orientation: portrait) {
    position:relative;
    justify-self: center;
    top: -4.5rem;
    
  }
  @media (max-width: 567px) and (orientation: portrait) {
    padding: 0;
  }
  
}

.footer-notPoweredBy{
  @media (min-width: 1025px) {
  justify-content: end;
  margin-right: 3rem;
  }

  @media (max-width: 1024px) and (orientation: portrait) {
    posoition:relative;
    justify-self: center;
    
    
  }
  .yauty-button {
  font-family: 'CircularStd-Book';
  font-size: 14px !important;
  color: #c6cfcf;
  text-decoration: none;
  }
}

.footer-home{
  background-color: #eff3f3;
  padding-left: calc(5dvw + 45px);
  @media (max-width: 576px) {
    padding-left: 17px;
    background-color: v-bind(userTertiaryColor);
  }
  @media (min-width: 577px) and (max-width: 1024px) and (orientation: portrait) {
    background-color: #eff3f3 !important;
  }
  @media (min-width: 769px) and (max-width: 1367px) and (orientation: landscape) {
    background-color: #eff3f3 !important;
  }
  .yauty-button {
  font-family: 'CircularStd-Book';
  font-size: 14px !important;
  color: #c6cfcf;
  text-decoration: none;
  }
}

// .footer-recovery{
//   @media (min-width: 1200px) and (orientation: landscape) {
//     padding-right: 1dvw;
    
//   }
// }
</style>
